/*
|--------------------------------------------------------------------------
| Component: NestedTreeSelector.jsx
| Author: Sayed Ahmed
| Description: Renders a TreeSelect input with support for recursive nested data.
|--------------------------------------------------------------------------
*/

import React, { useEffect, useState } from "react";
import { TreeSelect, Spin } from "antd";

// Recursively convert nested data to TreeSelect format
const convertAllChildrenKey = (data) => {
  if (!Array.isArray(data)) return [];

  return data.map(({ id, name, all_children = [] }) => ({
    title: name,
    value: id,
    children: convertAllChildrenKey(all_children),
  }));
};

const NestedTreeSelector = ({
  treeData = [],
  onSelect,
  loading = false,
  defaultValue = null,
  placeholder = "Please select",
}) => {
  const [value, setValue] = useState(defaultValue);

  // Sync with external default value changes
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  // Handle value change
  const handleChange = (newValue) => {
    setValue(newValue);
    onSelect(newValue);
  };

  const modifiedTreeData = convertAllChildrenKey(treeData);

  return (
    <TreeSelect
      style={{ width: "100%", height: "40px" }}
      value={value}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      treeData={modifiedTreeData}
      placeholder={placeholder}
      treeDefaultExpandAll
      onChange={handleChange}
      allowClear
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : "No data available"}
    />
  );
};

export default NestedTreeSelector;
